export default __webpack_public_path__ + "static/media/car-thumbnail.2080b51c.svg";